import * as plugins from './domtools.plugins';

export class Scroller {
  // TODO: move sweet scroll over to here;
}
